import { SidebarTrigger } from '@/components/atoms/Sidebar';
import { useLocalStorage } from 'usehooks-ts';
import UserConfig from './UserConfig';

export function AppNavbar() {
  const [isBannerVisible] = useLocalStorage('isBannerVisible', true);

  return (
    <nav className="sticky top-0 z-[50] flex h-[66px] w-full  items-center justify-end  border-b bg-gr-100 px-4  pr-[30px]">
      <UserConfig />
    </nav>
  );
}
